import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  FormControlLabel,
  Radio,
  FormControl,
  RadioGroup,
} from "@material-ui/core";
import * as React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  onSelectedDay: any;
  currentSelected: any;
}
class DisplayWeekDaysComponent extends React.Component<Props> {
  state = {
    selectedDay: "",
  };

  componentDidMount = () => {
    const { currentSelected } = this.props;
    this.setState({
      selectedDay: currentSelected,
    });
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    const { currentSelected } = this.props;
    if (prevProps.currentSelected !== currentSelected) {
      this.setState({
        selectedDay: currentSelected,
      });
    }
  };

  populateDefault = () => {};

  render() {
    const { onSelectedDay } = this.props;
    return (
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            name="weekDay"
            value={this.state.selectedDay}
            onChange={(event: any) => {
              this.setState(
                {
                  selectedDay: event.target.value,
                },
                () => {
                  onSelectedDay(this.state.selectedDay);
                }
              );
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <FormControlLabel
                value="Monday"
                control={<Radio />}
                label="Mon"
              />
              <FormControlLabel
                value="Tuesday"
                control={<Radio />}
                label="Tue"
              />
              <FormControlLabel
                value="Wednesday"
                control={<Radio />}
                label="Wed"
              />
              <FormControlLabel
                value="Thursday"
                control={<Radio />}
                label="Thu"
              />
              <FormControlLabel
                value="Friday"
                control={<Radio />}
                label="Fri"
              />
              <FormControlLabel
                value="Saturday"
                control={<Radio />}
                label="Sat"
              />
              <FormControlLabel
                value="Sunday"
                control={<Radio />}
                label="Sun"
              />
            </div>
          </RadioGroup>
        </FormControl>
      </div>
    );
  }
}
export default withStyles(styles)(DisplayWeekDaysComponent);
